import React from 'react'
import Jumbotron from '../../components/Jumbotron'
import PageTitle from '../../components/PageTitle'

const PageNotFound: React.FC = () => {
    return (
        <Jumbotron>
            <PageTitle displayName="Page Not Found" />
            <h1>404: Page Not Found</h1>
            <p>The URL you requested was not found. Please <a href='/'>return to the Home Page</a></p>
        </Jumbotron>
    )
}

export default PageNotFound